import { IAssignment } from '@medely/types';

export const fullAddress = (assignment: IAssignment): string =>
  [assignment.primary_location.address_first, assignment.primary_location.address_second ?? '']
    .filter(Boolean)
    .join(', ');

export const cityZip = (assignment: IAssignment): string => {
  const cityState = [
    assignment.primary_location.address_city,
    assignment.primary_location.state?.abbreviation,
  ]
    .filter(Boolean)
    .join(', ');
  return `${cityState} ${assignment.primary_location.address_zip}`;
};

export const couldShowFlexibleDates = (
  assignment: IAssignment & { assignment_request_status?: string },
): boolean => {
  if (assignment.assignment_request_status === 'offer_sent') {
    return false;
  }
  if (['w2_onboarding', 'booked', 'in_progress'].includes(assignment.status)) {
    return false;
  }
  return assignment.flexible_starts_date;
};
